<template>
  <a-table
    :columns="columns"
    :data-source="data"
    :pagination="false"
    :loading="isLoading"
    :rowKey="record => record.CreatedAt"
  >
    <div slot="pageName" slot-scope="record">{{record.PageName}} | {{record.FormName}}</div>
    <div class="center-col" slot="startedAt" slot-scope="record">{{formatDate(record.CreatedAt)}}</div>
    <div class="center-col" slot="endedAt" slot-scope="record">{{formatDate(record.EndTime)}}</div>
    <a class="center-col" slot="viewRecord" slot-scope="record">
      <router-link
        :to="{path:`/view-batch-logs/${record.FormId}/${record.LeadGenId}`, params: { formId: record.FbFormId, batchId: record.LeadGenId}, query: {pageName: encodeURIComponent(record.PageName), formName: encodeURIComponent(record.FormName)}}"
        target="_blank"
      >View Leads</router-link>
    </a>
  </a-table>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";

const columns = [
  {
    title: "Page Name | Form Name",
    key: "PageName",
    scopedSlots: { customRender: "pageName" }
  },
  {
    title: "Created at",
    key: "StartedAt",
    scopedSlots: { customRender: "startedAt" },
    className: "center-col"
  },
  {
    title: "Ended at",
    key: "EndTime",
    scopedSlots: { customRender: "endedAt" },
    className: "center-col"
  },
  {
    title: "Leads Found",
    dataIndex: "LeadsFound",
    key: "LeadsFound",
    className: "center-col"
  },
  {
    title: "Leads Processed",
    dataIndex: "LeadsProcessed",
    key: "LeadsProcessed",
    className: "center-col"
  },
  {
    title: "Leads Failed",
    dataIndex: "LeadsErrored",
    key: "LeadsErrored",
    className: "center-col"
  },
  {
    title: "",
    key: "ViewRecord",
    scopedSlots: { customRender: "viewRecord" },
    className: "center-col"
  }
];

export default {
  name: "BatchForms",
  props: ["record"],
  computed: {
    ...mapState(["user", "apiUrl"])
  },
  data() {
    return {
      columns,
      isLoading: false,
      data: []
    };
  },
  mounted() {
    this.isLoading = true;
    this.isLoading = true;
    axios({
      url: `${this.apiUrl}/logs`,
      headers: {
        Authorization: this.user.signInUserSession.idToken.jwtToken
      },
      params: { batchId: this.record.LeadGenId, action: "LOGS_PER_BATCH", processor: "facebook" }
    })
      .then(rslt => {
        this.data = rslt.data;
        this.isLoading = false;
      })
      .catch(err => {
        alert("Unable to load logs");
        this.isLoading = false;
      });
  },
  methods: {
    formatDate(d) {
      const date = new Date(d);
      return date.toLocaleString();
    },
    formatStatus(status) {
      if (status == "B-InProcess") {
        return "In process";
      }
      return "Completed";
    },
  }
};
</script>

<style scoped>
</style>